import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import StepperStep1 from 'assets/images/artists/stepper-step1.webp'
import StepperStep2 from 'assets/images/artists/stepper-step2.webp'
import AvatarGinaMadskull from 'assets/images/avatar-gina-madskull.webp'
import { Image } from 'components/common'
import { SpeechBubble } from 'components/common/cards'
import { useTranslations } from 'next-intl'
import { Link } from 'react-scroll'

import useHeaderStyles from './ArtistApplyHeader.styles'

type HeaderStyles = ReturnType<typeof useHeaderStyles>

const Title = ({ styles }: { styles: HeaderStyles }) => {
  return (
    <Typography
      component="h1"
      variant={styles.title.variant}
      sx={styles.title.wrapper}
    >
      Become <span>inckd.</span> artist
    </Typography>
  )
}

const Gina = ({ styles, bubble }: { styles: HeaderStyles; bubble: string }) => {
  return (
    // id added for stepper link to scroll to the element above the form on mobile
    <Box sx={styles.imageWrapper} id="apply-form-start">
      <Image
        src={AvatarGinaMadskull}
        width={styles.image.width}
        height={styles.image.height}
        alt="hero image"
      />
      <SpeechBubble label={bubble} direction="right" />
    </Box>
  )
}

const Stepper = ({ styles, step }: { styles: HeaderStyles; step: number }) => {
  return (
    <Box sx={styles.stepperWrapper}>
      <Image
        src={step === 1 ? StepperStep1 : StepperStep2}
        alt="stepper"
        width="374px"
        height="451px"
      />
    </Box>
  )
}

/**
 *
 * @description A component that renders on the page.
 * @param {ArtistApplyHeaderProps} ArtistApplyHeaderProps
 *
 */
const ArtistApplyHeader = ({ step }: { step: number }) => {
  const styles = useHeaderStyles()
  const t = useTranslations()
  const { breakpoints } = useTheme()

  const isAboveMD = useMediaQuery(breakpoints.up('md'))

  return (
    <Box sx={styles.container}>
      {isAboveMD ? (
        <Gina
          styles={styles}
          bubble={step === 1 ? t('bubble') : t('bubble2')}
        />
      ) : (
        step === 1 && <Title styles={styles} />
      )}

      {isAboveMD ? (
        <Stepper styles={styles} step={step} />
      ) : step === 1 ? (
        <Link to="apply-form-start" smooth>
          <Stepper styles={styles} step={step} />
        </Link>
      ) : (
        <Gina
          styles={styles}
          bubble={step === 1 ? t('bubble') : t('bubble2')}
        />
      )}

      {!isAboveMD &&
        (step === 1 ? (
          <Gina
            styles={styles}
            bubble={step === 1 ? t('bubble') : t('bubble2')}
          />
        ) : (
          <Stepper styles={styles} step={step} />
        ))}
    </Box>
  )
}

export default ArtistApplyHeader
